export default {
  props: {
    item: { type: Object, required: true },
    line: { type: Object, default: () => ({}) },
    itemData: { type: [Object, Array, String, Number, Boolean], default: null },
    page: { type: [String, Number], default: null },
    actionResolver: { type: Function, default: null },
  },

  methods: {
    resolveTemplate(value, fallback = '') {
      if (value === undefined || value === null) return fallback
      if (typeof value !== 'string') return value
      const withItemValues = value.replace(/\[\[item\|\|([^\]]+)\]\]/g, (match, path) => {
        if (path === 'value') {
          if (this.itemData === null || this.itemData === undefined) return ''
          if (typeof this.itemData === 'object' && Object.prototype.hasOwnProperty.call(this.itemData, 'value')) return String(this.itemData.value)
          return String(this.itemData)
        }
        if (path === 'index') return this.itemData && this.itemData.__index !== undefined ? String(this.itemData.__index) : ''
        const resolved = this.itemPathValue(this.itemData, path)
        return resolved === null || resolved === undefined ? '' : String(resolved)
      })
      return this.replaceBy({ text: withItemValues, line: this.line, page: this.page })
    },
    resolveValue(value, legacySource, fallback = '') {
      const rawValue = legacySource === 'field' && !String(value || '').includes('[[')
        ? this.line[value]
        : value
      const resolved = this.resolveTemplate(rawValue, fallback)
      return resolved === undefined || resolved === null ? fallback : resolved
    },
    formatAffixedValue(value, prefix = '', suffix = '') {
      const resolvedPrefix = prefix === null || prefix === undefined ? '' : String(prefix)
      const resolvedSuffix = suffix === null || suffix === undefined ? '' : String(suffix)
      const before = resolvedPrefix === ''
        ? ''
        : `${resolvedPrefix}${/\s$/.test(resolvedPrefix) ? '' : ' '}`
      const after = resolvedSuffix === ''
        ? ''
        : `${/^\s/.test(resolvedSuffix) ? '' : ' '}${resolvedSuffix}`
      return `${before}${value === null || value === undefined ? '' : value}${after}`
    },
    flexValue(value) {
      return { start: 'flex-start', end: 'flex-end' }[value] || value
    },
    itemPathValue(source, path) {
      if (source === null || source === undefined) return undefined
      if (Object.prototype.hasOwnProperty.call(Object(source), path)) return source[path]
      return String(path).split(/[. ]/).filter(Boolean).reduce((value, key) => (
        value !== null && value !== undefined ? value[key] : undefined
      ), source)
    },
    safeImageUrl(value) {
      if (typeof value !== 'string') return ''
      const url = value.trim()
      if (!url || /^javascript:/i.test(url) || /^data:(?!image\/(?:png|jpe?g|gif|webp);base64,)/i.test(url)) return ''
      if (/^[a-z][a-z\d+.-]*:/i.test(url) && !/^(https?:|blob:|data:image\/)/i.test(url)) return ''
      return url.startsWith('//') ? '' : url
    },
  },
}
